import { Injectable } from '@angular/core';
import { Confirm } from '@app/shared/components/_ui/confirm/confirm.types';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ConfirmService {
  private subject = new Subject<Confirm>();

  constructor() { }

  getObservable(): Observable<Confirm> {
    return this.subject.asObservable();
  }

  confirm(text:string, onConfirmCallback:Function, onCancelCallback?:Function, options?:any) {
    this.subject.next(new Confirm(text, onConfirmCallback, onCancelCallback, options));
  }
}
